import type { ReactNode } from 'react'
import { Logo } from '../brand/Logo'

type AuthLayoutProps = {
  title: string
  description: string
  children: ReactNode
  footer?: ReactNode
}

/** Split auth layout from HRS-REVISED-UI-MOCKUP.html */
export function AuthLayout({ title, description, children, footer }: AuthLayoutProps) {
  return (
    <div className="fixed inset-0 z-50 grid grid-cols-1 md:grid-cols-2">
      <div className="hidden flex-col justify-between bg-green-900 p-12 text-white md:flex">
        <Logo variant="light" />
        <div>
          <p className="mb-3 text-sm font-semibold text-gold">
            Clinical peer-review platform
          </p>
          <h1 className="font-display text-4xl leading-tight font-bold">
            Authority that is earned. Precision with warmth.
          </h1>
          <p className="mt-4 max-w-md text-white/75">
            Document cases, invite reviewers into realtime discussion, and share to the
            national learning hub — securely.
          </p>
          <div className="mt-8 flex gap-8 text-sm text-white/75">
            <div>
              <div className="font-display text-2xl font-bold text-gold">25</div>
              Modules
            </div>
            <div>
              <div className="font-display text-2xl font-bold text-white">Realtime</div>
              Review
            </div>
            <div>
              <div className="font-display text-2xl font-bold text-white">RBAC</div>
              Secured
            </div>
          </div>
        </div>
        <div className="text-xs text-white/50">
          © 2026 PeerMed
        </div>
      </div>

      <div className="flex items-center justify-center bg-white p-8">
        <div className="w-full max-w-sm">
          <div className="mb-6 md:hidden">
            <Logo />
          </div>
          <h2 className="font-display text-3xl font-bold">{title}</h2>
          <p className="mt-1 text-ink-600">{description}</p>
          <div className="mt-6">{children}</div>
          {footer && <div className="mt-6">{footer}</div>}
        </div>
      </div>
    </div>
  )
}
